import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { RunTimeDataService } from '@leandredev/common_ng_14';
import { Observable, filter, map, switchMap } from 'rxjs';
import { IUserAdmin } from '@leandredev/dcbm-common-lib/dist/interfaces';
import { interfaces } from '@leandredev/dcbm-common-lib';
import * as dcbm from '@leandredev/dcbm-ng-lib';
import { I_Claim } from 'src/app/utils/interfaces';

const PROFILE_KEY = 'ConfService';
@Injectable()
export class ProfileService {
  public profile: Observable<IUserAdmin> = this.runTimeDataService
    .getObservableStore(PROFILE_KEY)
    .pipe(filter((profile: IUserAdmin) => Boolean(profile)));

  constructor(private runTimeDataService: RunTimeDataService, private api: ApiService) {}

  public getServiceResposabilityForUser(): Observable<interfaces.IDcbmService> {
    return this.profile.pipe(
      filter((x) => !!x),
      switchMap((profile) => this.api.collections.DcbmService.get(`manager/${profile._id}/=/`).pipe(dcbm.ApiHelper.resultToObj('No service')))
    );
  }

  public isManagerObs(serviceID: string): Observable<boolean> {
    return this.getServiceResposabilityForUser().pipe(map((v) => String(serviceID) === String(v._id)));
  }

  public updateProfile(claim: I_Claim): void {
    this.runTimeDataService.updateStore(PROFILE_KEY, claim);
  }

  public clearProfile(): void {
    this.runTimeDataService.updateStore(PROFILE_KEY, null);
  }
}
